import { useQuery } from "@tanstack/react-query";
// import { premiumProjectionResponseMapping } from "../../mapping/premiumProjectionResponseMapping.js";
import { premiumProjectionResponseTableMapping } from "../../mapping/premiumProjectionResponseTableMapping.js";
import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";
//----------------------------------------------------------------

const fetchPremiumProjectionData = async (accessToken, openErrorModal) => {
  const response = await request({
    url: "/premiumProjection",
    method: "GET",
    accessToken: accessToken,
  });
  if (200 !== response.status) {
    openErrorModal();
    throw response;
  } else {
    let returnResponse = premiumProjectionResponseTableMapping(response.data);
    return returnResponse;
  }
};

export const useGetPremiumProjectionData = (accessToken, enabled = true) => {
  const { openErrorModal } = useSharedData();
  return useQuery({
    queryKey: ["premiumProjectionData"],
    queryFn: async () =>
      await fetchPremiumProjectionData(accessToken, openErrorModal),
    enabled: accessToken != null && enabled === true,
    refetchOnWindowFocus: false,
  });
};
